import { render, staticRenderFns } from "./AdminDataLayers.vue?vue&type=template&id=5901c66c&"
import script from "./AdminDataLayers.vue?vue&type=script&lang=js&"
export * from "./AdminDataLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports